const resolvedPromise = Promise.resolve();
export const enqueuePostPromiseJob = typeof process === 'object' && typeof process.nextTick === 'function'
    ? (fn) => {
        resolvedPromise.then(() => process.nextTick(fn));
    }
    : setImmediate || setTimeout;

//# sourceMappingURL=enqueuePostPromiseJob.js.map
